import {Component, OnInit} from '@angular/core';
import {FieldComponentAbstract} from '../abstracts/FieldComponentAbstract';

@Component({
  selector: 'app-decimal-field',
  templateUrl: './decimal-field.component.html',
  styleUrls: ['./decimal-field.component.css']
})
export class DecimalFieldComponent extends FieldComponentAbstract implements OnInit {

  ngOnInit(): void {
    this.completed = this.fieldValue.decimal_value != null;
  }

  getFormattedValue(): string {
    const num = Number(this.fieldValue.decimal_value);
    const remainder = num % 1;
    if (remainder === 0) {
      return num + '.00';
    }
    return String(num);
  }

  handleChange(data: string) {
    this.completed = data != null;
    this.fieldValue.decimal_value = parseFloat(String(data));
    this.onChange(this.fieldValue);
  }

}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/fields/components/decimal-field/decimal-field.component.ts